// @flow
import React from 'react'
import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`

const Component = styled.div`
  width: 56px;
  height: 56px;
  border: 8px solid rgba(0, 82, 236, 0.25);
  border-top-color: #0052ec;
  border-radius: 50%;
  position: relative;
  animation: ${rotate} 1s linear infinite;
`

const Spinner = ({ style }: { style?: Object }) => <Component style={style} />

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js